import React, { useState } from "react"
import styled from "styled-components"
import TextWithIcon from "./TextWithIcon"
import CheckIcon from "../../../icons/check.svg?react"
import { theme } from "component_library/styles/theme"
import Icon from "../react/icon/Icon"
import { DropdownIconNames } from "../react/icon/dropdownIconNames"

export interface Item extends SingleItem {
  subItems?: SingleItem[]
}

interface SingleItem {
  label?: string
  value: string
  selected?: boolean
  disabled?: boolean
  icon?: string
}

interface MenuWindowProps {
  onChange: (string) => void
  items: Item[]
  selected: string
}

const MenuWindowWrapper = styled("div")`
  position: absolute;
  z-index: 9999;
  right: 0;
  white-space: nowrap;
`

const MenuWindowContainer = styled.div`
  max-height: 600px;
  padding: 8px;
  margin: 0;
  background: #ffffff;
  border: 1px solid #cdd8e5;
  box-shadow: 0px 8px 20px rgba(2, 35, 76, 0.08);
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 12px;
  list-style: none;
  line-height: 1.2;
  overflow-y: auto;
`

const ListItem = styled.button`
  background-color: #ffffff;
  border: none;
  padding: 0 6px;
  width: 100%;
  text-align: left;
  height: 32px;
  cursor: pointer;
  display: block; /* Make the buttons appear below each other */
  &:focus {
    outline: 0;
    box-shadow: none;
  }
  &:hover {
    background: ${({ theme }) => theme.gray_100};
    cursor: pointer;
  }
  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
    color: yellow;
  }
`

const Check = styled(CheckIcon)`
  width: 16px;
  height: 12px;
`

const MenuWindow = ({ items, onChange, selected }: MenuWindowProps) => {
  return (
    <MenuWindowWrapper>
      <MenuWindowContainer>
        {items.map((item) => (
          <>
            <ListItem
              key={item.label}
              onClick={() => onChange(item)}
              disabled={item.disabled}
            >
              <TextWithIcon
                textType="body"
                fontWeight={!item.subItems ? "500" : "700"}
                icon={
                  selected ? (
                    <Check
                      fill={
                        selected === item.value ? theme.green_600 : theme.white
                      }
                    />
                  ) : item.icon ? (
                    <Icon name={DropdownIconNames[item.icon]} />
                  ) : (
                    ""
                  )
                }
                fontColor="blue_800"
                gap="20px"
              >
                {item.label}
              </TextWithIcon>
            </ListItem>

            {item.subItems?.map((subItem) => (
              <ListItem key={subItem.label} onClick={() => onChange(subItem)}>
                <TextWithIcon
                  textType="body"
                  fontWeight="500"
                  icon={
                    <Check
                      fill={
                        selected === subItem.value
                          ? theme.green_600
                          : theme.white
                      }
                    />
                  }
                  fontColor="blue_800"
                  gap="20px"
                >
                  <div style={{ marginLeft: "12px" }}>{subItem.label}</div>
                </TextWithIcon>
              </ListItem>
            ))}
          </>
        ))}
      </MenuWindowContainer>
    </MenuWindowWrapper>
  )
}

export default MenuWindow
